<template>
    <a-button-group class="scale-wrapper">
        <a-input-number :min="min" :max="max" @change="updateData" m style="width:90px;" size="small" addonAfter="%" type="number" v-model="temp_scaleNumber"/>
        <a-button @click="handleClickEvent('sub')" size="small">
            -
        </a-button>
        <a-button @click="handleClickEvent('add')" size="small">
            +
        </a-button>
    </a-button-group>
</template>

<script>
export default {
    name: "zoomWidget",
    components: {},
    props: {
        // 缩放等级
        scaleNumber:{
            type:Number,
            default:100,
        },
        // 步骤
        step:{
            type:Number,
            default:5,
        },
        min:{
            type:Number,
            default:30,
        },
        max:{
            type:Number,
            default:150,
        },
    },
    watch:{
        scaleNumber:{
            handler(newVal){
                this.temp_scaleNumber = newVal;
            },
            immediate:true,
        },
    },
    data() {
        return {
            temp_scaleNumber : 0,
        }
    },
    methods: {
        handleClickEvent(type){
            // 加
            if(type == 'add' && (this.temp_scaleNumber + this.step <= this.max)){
                this.temp_scaleNumber += this.step
                this.updateData();
            }
            // 减
            if(type == 'sub' && (this.temp_scaleNumber - this.step >= this.min)){
                this.temp_scaleNumber -= this.step;
                this.updateData();
            }
        },
        updateData(){
            this.$emit('change',this.temp_scaleNumber);
            this.$store.commit('updateState',{scaleNumber:this.temp_scaleNumber});
        }
    },
    mounted() {
    },
}
</script>

<style lang="less" scoped>
.scale-wrapper{
    /deep/.ant-input-number{
        border-right:0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
}
</style>